"use client";

import { RenderErrorFallback } from "@/components/errors/render-error-fallback";

/**
 * ルート直下の表示中の例外（`/login` と、保護領域のレイアウト自体の例外）。
 *
 * @param props.error - 例外。
 * @param props.unstable_retry - 再試行。
 */
export default function RootError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  return <RenderErrorFallback error={error} retry={unstable_retry} />;
}
